var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container mx-auto py-8 px-4 lg:px-0"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }